import React from "react";

import Web3Apps from "components/Web3";
const Web3 = () => {
  return (
      <Web3Apps></Web3Apps>
  )
};

export default Web3;